import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/** Pantallas con formulario que deben advertir antes de abandonar cambios sin guardar. */
export interface HasUnsavedChanges {
  /** `true` permite salir; un observable resuelve tras la confirmación del usuario. */
  canDeactivate(): boolean | Observable<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = component => component.canDeactivate();
